import { EventAttributes } from '@/types'
import { CloneEventMutation } from './__generated__/clone_mutation'
import { Mutation as CloneMutation } from './clone_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'
import { EditEventQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'

type Event = EditEventQuery['events']['nodes'][0]

interface Props {
  onSuccess: () => void
  eventId: string
}

export const Form = ({ onSuccess, eventId }: Props) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData,
    attributes
  } = useForm<CloneEventMutation, EventAttributes, EditEventQuery, Event>({
    id: eventId,
    initializer: event => ({
      description: event.description,
      details: event.details,
      dateOut: event.dateOut,
      dateStart: event.dateStart,
      dateEnd: event.dateEnd,
      dateReturn: event.dateReturn,
      state: event.state,
      clientId: event.client.id,
      venueId: event.venue?.id,
      warehouseId: event.warehouse?.id
    }),
    query: EditQuery,
    queryKey: 'events',
    mutation: CloneMutation,
    resultKey: 'cloneEvent',
    refetchQueries: [TableQuery]
  })

  console.log(attributes)
  console.log(eventId)

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.cloneEvent?.event?.id) return

    navigate(`/events/${mutationData?.cloneEvent?.event?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Description', field: 'description', type: 'text' }) }
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Date out', field: 'dateOut', type: 'datetime' }) }
        { formBuilder.buildField({ name: 'Date start', field: 'dateStart', type: 'datetime' }) }
        { formBuilder.buildField({ name: 'Date finish', field: 'dateEnd', type: 'datetime' }) }
        { formBuilder.buildField({ name: 'Date return', field: 'dateReturn', type: 'datetime' }) }
      </div>
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
